import type { Editor } from '@tiptap/react';

export function getAnchorRect(
  editor: Editor,
  pos: number,
  containerEl: HTMLElement | null
): { top: number; left: number } | null {
  if (!containerEl) return null;
  let coords: { top: number; bottom: number; left: number; right: number };
  try {
    coords = editor.view.coordsAtPos(pos);
  } catch {
    return null;
  }
  const container = containerEl.getBoundingClientRect();
  return {
    top: coords.bottom - container.top,
    left: coords.left - container.left,
  };
}
